// The athlete feature flag: the release goes to prod without athletes, so
// the sign-up role is hidden until NEXT_PUBLIC_ATHLETE_ENABLED=true (baked in
// at build time from deploy/envs/<env>/.env). Off when unset.

export const isAthleteEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_ATHLETE_ENABLED === 'true'

/** The sign-up roles a user may pick: Athlete only while the flag is on. */
export function availableSignupRoles<T extends string>(
  roles: readonly T[]
): T[] {
  return isAthleteEnabled()
    ? [...roles]
    : roles.filter(role => role !== 'ATHLETE')
}
